<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Task to-do</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="dashboard">Home</a>
                </li>
                <li class="breadcrumb-item active">Task to-do</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="row justify-content-end">
          <div class="col-sm-4">
        
            <div class="text-right">
              <button @click='showTaskStatusTable()' class="btn btn-success waves-effect mt-2 mb-2"
               style="margin-right:1%" type="button" data-toggle="modal" id="" data-target="#manage-status">Manage Status Types</button>
              <button
                class="btn btn-success waves-effect mt-2 mb-2"
                type="button"
                data-toggle="modal"
                id=""
                name="nam1"
                @click="AddTask()"
              >
                <i class="fas fa-plus fa-2x"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="card p-3">
          <table
            class="
              table
              display
              table-bordered
              text-center
              table-striped
              no-wrap
            "
            id="clmtable1"
          >
            <thead class="thead-dark">
              <tr>
                <th class='no-sort'>Action</th>
                <th>Task Name</th>
                <th>Task Description</th>
                <th>Task ID</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="task in tasksList" :key="task.taskID">
                <td>
                  <div class="btn-group">
                    <button
                      type="button"
                      class="btn btn-warning"
                      data-toggle="modal"
                      @click="GetTaskById(task)"
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      class="
                        btn btn-warning
                        dropdown-toggle dropdown-toggle-split
                      "
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu animated flipInY">
                      <a
                        class="dropdown-item"
                        href="javascript:void(0)"
                        id="resourcesArchive"
                        name="resourcesArchive"
                        @click="DeleteTask(task)"
                        >Archive</a
                      >
                    </div>
                  </div>
                </td>
                <td>{{ task.taskName }}</td>
                <td>{{ task.description }}</td>
                <td>TID-{{ task.taskCode }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->

    <!-- Task  -->
    <div
      id="taskid"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Add Task</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <form class="floating-labels m-t-40">
              <div class="row">
                <div class="col">
                  <!-- Resource ID -->
                  <div
                    class="form-group"
                    v-bind:class="[
                      aSingleTask.taskName.length > 0 ? 'focused' : '',
                    ]"
                  >
                    <span class="p-float-label">
                      <InputText
                        maxlength="155"
                        name=""
                        class="form-control float-class"
                        id=""
                        required=""
                        type="text"
                        v-model="aSingleTask.taskName"
                      />
                      <span class="bar"></span>
                      <label for="" id="font1"
                        >Task Name<span style="color: red"> *</span></label
                      >
                    </span>
                  </div>
                  <!-- Task Name -->
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <!-- Task Desciption -->
                  <div
                    class="form-group"
                    v-bind:class="[
                      aSingleTask.description.length > 0 ? 'focused' : '',
                    ]"
                  >
                    <span class="p-float-label">
                      <InputText
                        name=""
                        class="form-control float-class"
                        id=""
                        maxlength="255"
                        required=""
                        type="text"
                        v-model="aSingleTask.description"
                      />
                      <span class="bar"></span>
                      <label for="" id="font1"
                        >Task Desciption</label
                      >
                    </span>
                  </div>
                  <!-- Task Desciption -->
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="CreateTask()"
              id="createRes_btn"
              name="createRes_btn"
              class="btn btn-outline-success waves-effect waves-light col-12"
            >
              Add Task
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Task -->
    <!--  Update Task  -->
    <div
      id="taskIdEdit"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Update Task</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <form class="floating-labels m-t-40">
              <div class="row">
                <div class="col">
                  <!-- Resource ID -->
                  <div
                    class="form-group"
                    v-bind:class="[
                      aSingleTask.taskName.length > 0 ? 'focused' : '',
                    ]"
                  >
                    <span class="p-float-label">
                      <InputText
                        maxlength="155"
                        name=""
                        class="form-control float-class"
                        id=""
                        required=""
                        type="text"
                        v-model="aSingleTask.taskName"
                      />
                      <span class="bar"></span>
                      <label for="" id="font1"
                        >Task Name<span style="color: red"> *</span></label
                      >
                    </span>
                  </div>
                  <!-- Task Name -->
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <!-- Task Desciption -->
                  <div
                    class="form-group"
                    v-bind:class="[
                      aSingleTask.description.length > 0 ? 'focused' : '',
                    ]"
                  >
                    <span class="p-float-label">
                      <InputText
                        name=""
                        class="form-control float-class"
                        id=""
                        maxlength="255"
                        required=""
                        type="text"
                        v-model="aSingleTask.description"
                      />
                      <span class="bar"></span>
                      <label for="" id="font1"
                        >Task Desciption</label
                      >
                    </span>
                  </div>
                  <!-- Task Desciption -->
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="UpdateTask()"
              id="createRes_btn"
              name="createRes_btn"
              class="btn btn-outline-success waves-effect waves-light col-12"
            >
              Update Task
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Update Task -->
    <TaskStatusComponent v-show='TaskStatusShow==true' ref='taskStatusComponent'></TaskStatusComponent>

    <div id="template-name" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none; background-color:#00000075;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Add Task Status</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                </div>
                <TaskStatusAddComponent :tableRefreash="getTaskStatusTable" :closeModal="closeAddTemplateModal"></TaskStatusAddComponent>
            </div>
        </div>
    </div>
   
    <!-- No idea Modal -->
    
    <!-- No idea Modal -->
  </div>
</template>

<script src='./TasksJs.js'></script>

<style>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox  wa*/
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #00c292;
}

input:focus + .slider {
  box-shadow: 0 0 1px #00c292;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  height: 34px;
  width: 60px;
  border-radius: 24px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
<style scoped>
.float-textarea,
.float-class:hover {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 1px solid rgb(235, 235, 235);
  /* / box-shadow: none; / */
  width: 98%;
}

.float-textarea:focus {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 2px solid rgb(240, 141, 11);
  /* / box-shadow: none; / */
  width: 98%;
}

.float-class,
.float-class:hover {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  /* / border-bottom: 2px solid rgb(240, 141, 11); / */
  border-bottom: 1px solid rgb(235, 235, 235);
  box-shadow: none;
}
.float-class:focus {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 2px solid rgb(240, 141, 11);
  box-shadow: none;
}
#font1 {
  font-weight: 600;
  font-size: 15px;
  margin-left: -7px;
}
</style>